import { useIntl } from 'react-intl';
import CTA from '../../../atoms/CTA';

const CookieSettingsButton = () => {
  const intl = useIntl();
  return (
    <CTA
      handleBtnClick={() => {
        if (typeof window !== 'undefined' && window.OneTrust) {
          window.OneTrust.ToggleInfoDisplay();
        }
      }}
      text={intl.formatMessage({
        id: `cookie.settings.link.label`,
      })}
      href={'#'}
      title={intl.formatMessage({
        id: `cookie.settings.link.label`,
      })}
      skin="PRIMARY"
    />
  );
};

export default CookieSettingsButton;
